import React from "react";
import NavBar from "../../components/NavBar";
import { useHistory } from "react-router-dom";
import './entertagnumber.scss';
import { AppContext } from '../../AppContext';
import { NextIcon, TagIcon } from '../../components/Icons';
import Footer from "../../components/SessionFooter";

const EnterCowNumber: React.SFC<{}> = () => {

	const [tagNumber, setTagNumber] = React.useState('');
	const [disableButtons, setDisableButtons] = React.useState(true);
	const [displayModal, setDisplayModal] = React.useState(false);
	const context = React.useContext(AppContext);
	let history = useHistory();
	let state = context.state;

	const appendTagNumberDigit = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		setDisableButtons(false);
		setTagNumber( tagNumber + event.currentTarget.value );
	}

	const removeTagNumberDigit = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		setTagNumber(tagNumber.substring(0, tagNumber.length - 1));
		if (tagNumber.length === 0) { setDisableButtons(true); }
	}

	const nextPageHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		

		for (let animal of state.animals) {
			if(animal.tagNumber.toString() === tagNumber) { 
				setDisplayModal(true);
				return false;
			}
		}
		state.current.tagNumber = Number.parseInt(tagNumber);
		context.setState(state);
		history.push('/tail_condition')	
	}

	const summaryHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		history.push('/summary#' + context.state.session_id);
	}

	const doneHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		history.push('/');
	}

	const changeTagHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		setDisplayModal(false);
	}

	const overwriteHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		let tag = Number.parseInt(tagNumber);
		let index = state.animals.findIndex(animal => animal.tagNumber === tag);
		state.animals.splice(index,1);
		state.current.tagNumber = Number.parseInt(tagNumber);
		context.setState(state);
		localStorage.setItem('session', JSON.stringify(state));
		history.push('/tail_condition')
	}

    return (
      <>
        <NavBar 
        	title={context.state.herd}
        	backBtnTitle="Home"
        	actionBtnTitle="Summary"
        	backBtnClick={doneHandler}
        	actionBtnClick={summaryHandler}
        />
		<h1>Enter tag number</h1>
		<div className="content-pane">
	        <div className="enter-tag-form">
	        	<label className="rpg_form-control">
	        		<input type="text" placeholder="000" value={tagNumber} readOnly />
	        	</label>
				<div className="tag-number-grid">
					<button className="btn-1 rpg_button" value="1" onClick={appendTagNumberDigit} >1</button>
					<button className="btn-2 rpg_button" value="2" onClick={appendTagNumberDigit} >2</button>
					<button className="btn-3 rpg_button" value="3" onClick={appendTagNumberDigit} >3</button>
					<button className="btn-4 rpg_button" value="4" onClick={appendTagNumberDigit} >4</button>
					<button className="btn-5 rpg_button" value="5" onClick={appendTagNumberDigit} >5</button>
					<button className="btn-6 rpg_button" value="6" onClick={appendTagNumberDigit} >6</button>
					<button className="btn-7 rpg_button" value="7" onClick={appendTagNumberDigit} >7</button>
					<button className="btn-8 rpg_button" value="8" onClick={appendTagNumberDigit} >8</button>
					<button className="btn-9 rpg_button" value="9" onClick={appendTagNumberDigit} >9</button>
					<button className="btn-x rpg_button warning"  onClick={removeTagNumberDigit} >DEL</button>
					<button className="btn-0 rpg_button" value="0" onClick={appendTagNumberDigit} >0</button>
					<button className="btn-next rpg_button action" disabled={disableButtons} onClick={nextPageHandler} ><NextIcon fill="#FFFFFF" /></button>
				</div>
	        </div>
		</div>
		<Footer tag={state.previous.tagNumber} />
		{displayModal &&
			<div className="curtain">
				<div className="modal">
					<p>Duplicate<br/>tag number</p>
					<div className="modal_tag">
						<TagIcon fill="#FFDD57" className="" />
						<h2>{tagNumber}</h2>
					</div>
					<button className="btn-next rpg_button action small" onClick={changeTagHandler} >Change</button>
					<button className="btn-next rpg_button warning small" onClick={overwriteHandler} >Overwrite</button>
				</div>
			</div>
		}
	</>
     )
  }

export default EnterCowNumber;